import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import { preloadLoad } from '../../audio-player'
import type VideoPlayer from './video-player.vue'

export const videoFormat = [
  'MP4',
  'WebM',
  'OGG',
  'MOV',
  'AVI',
  'WMV',
  'FLV',
  'MKV',
]

export const videoPlayerProps = buildProps({
  src: {
    type: String,
    required: true,
  },
  // 视频封面图像 URL
  poster: {
    type: String,
    default: '',
  },
  // 页面加载后自动播放视频
  autoplay: {
    type: Boolean,
    default: false,
  },
  // 视频循环播放
  loop: {
    type: Boolean,
    default: false,
  },
  // 预加载设置
  preload: {
    type: String,
    default: 'auto',
    values: preloadLoad,
  },
  // 静音
  muted: {
    type: Boolean,
    default: false,
  },
  // 显示视频控制界面
  controls: {
    type: Boolean,
    default: true,
  },
  width: {
    type: [String, Number],
    default: '100%',
  },
  height: {
    type: [String, Number],
    default: 'auto',
  },
  format: {
    type: String,
    default: 'MP4',
    values: videoFormat,
  },
} as const)

// props
export type VideoPlayerProps = ExtractPropTypes<typeof videoPlayerProps>

// instance
export type VideoPlayerInstance = InstanceType<typeof VideoPlayer>
